import { GameConstants } from "../../../GameConstants";
import { BattleManager } from "../BattleManager";
import { GameVars } from "../../../GameVars";

export class TarFx extends Phaser.GameObjects.Container {

    public static TILE_SIZE = 64;
 
    constructor(scene: Phaser.Scene, height: number) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH + TarFx.TILE_SIZE;
        this.y = GameConstants.GAME_HEIGHT / 2;

        let tile: Phaser.GameObjects.Image;

        // esquina superior izquierda
        tile = new Phaser.GameObjects.Image(this.scene, -TarFx.TILE_SIZE, (-1 - height / 2 + .5) * TarFx.TILE_SIZE, "texture_atlas_3", "brea_tile_01");
        tile.setOrigin(0);
        this.add(tile);

        // la parte superior
        for (let c = 0; c < 16; c ++) {

            tile = new Phaser.GameObjects.Image(this.scene, TarFx.TILE_SIZE * c, (-1 - height / 2 + .5) * TarFx.TILE_SIZE, "texture_atlas_3", "brea_tile_04");
            tile.setOrigin(0);
            this.add(tile);
        }

        // la parte central
        for (let r = 0; r < height; r ++) {

            for (let c = 0; c < 16; c ++) {

                tile = new Phaser.GameObjects.Image(this.scene, TarFx.TILE_SIZE * c, (r - height / 2 + .5) * TarFx.TILE_SIZE, "texture_atlas_3", "brea_tile_05");
                tile.setOrigin(0);
                this.add(tile);
            }
        }

        // la parte frontal
        for (let r = 0; r < height; r ++) {
            tile = new Phaser.GameObjects.Image(this.scene, -TarFx.TILE_SIZE,  (r - height / 2 + .5) * TarFx.TILE_SIZE, "texture_atlas_3", "brea_tile_02");
            tile.setOrigin(0);
            this.add(tile);
        }

        // esquina inferior izquierda
        tile = new Phaser.GameObjects.Image(this.scene, -TarFx.TILE_SIZE, (height / 2 + .5) * TarFx.TILE_SIZE, "texture_atlas_3", "brea_tile_03");
        tile.setOrigin(0);
        this.add(tile);

        // la parte inferior
        for (let c = 0; c < 16; c ++) {

            tile = new Phaser.GameObjects.Image(this.scene, TarFx.TILE_SIZE * c, (height / 2 + .5) * TarFx.TILE_SIZE, "texture_atlas_3", "brea_tile_06");
            tile.setOrigin(0);
            this.add(tile);
        }
    }

    public activate(): void {

        this.x = GameConstants.GAME_WIDTH + TarFx.TILE_SIZE;
        this.scaleY = 1;
        this.alpha = 1;
        
        this.scene.tweens.add({
            targets: this,
            x: 0,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: GameVars.timeStepFactor === 1 ? 1000 : 500
        });

        this.scene.time.addEvent({ delay: GameVars.timeStepFactor === 1 ? 250 : 75, callback: () => {
            BattleManager.onFreezeAttackDeployed();
        }, callbackScope: this});
    }

    public deactivate(): void {

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 600 : 150
        });
    }
}
